export default __webpack_public_path__ + "static/media/ExitIntent_MaskGroup.4edb51af.png";